// Audit checks — 02 §3. PASSIVE checks only: the fetcher never submits a form (D74 / 05 §3).
// Pages are RENDERED in Chromium before extraction: most real sites draw their content with
// JavaScript, and reading raw HTML reported eight false weaknesses on a single measured lead.
export const CHECKS = [
    'mobile_viewport',
    'ssl',
    'booking',
    'viber',
    'whatsapp',
    'contact_form',
    'prices',
    'team_page',
    'services_pages',
    'reviews_embed',
    'privacy_policy',
    'terms',
    'legal_disclosure',
    'lang_bg',
    'lang_en',
    'maps_embed',
    'broken_links',
    'form_wired',
    'perf_speed',
    'content_freshness',
    'google_profile',
    // Browser-only. These need a real render at real viewport widths, which is why they did not
    // exist while the audit read raw HTML — v1 had them via Playwright and v2 did not.
    'mobile_layout',
    'tablet_layout',
    'js_errors',
];
//# sourceMappingURL=checks.js.map